/**
 * Determines whether this page is loaded in an iframe
 */
export function inIframe() {
	try {
		return window.self !== window.top && window['Cypress'] == null;
	} catch (e) {
		return true;
	}
}
